// frontend/packages/business-console/src/components/build-interview/CompletionRing.jsx
//
// SVG donut showing brief completion percent, with a blue->purple gradient
// stroke and the percent in the centre. Used in the brief panel header (Website
// Builder Redesign, Phase 1).

import React from 'react';
import { Box, Typography } from '@mui/material';
import useTokens from '../primitives/useTokens';

export default function CompletionRing({ percent = 0, size = 52, stroke = 6 }) {
  const t = useTokens();
  const pct = Math.max(0, Math.min(100, Number(percent) || 0));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (pct / 100) * c;
  // Unique-ish gradient id so multiple rings on a page do not collide.
  const gradId = `briefRing-${size}-${stroke}`;
  return (
    <Box sx={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2563eb" />
            <stop offset="55%" stopColor="#7c3aed" />
            <stop offset="100%" stopColor="#ab2ddd" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={t.grayBorder}
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={`url(#${gradId})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c - dash}`}
          style={{ transition: 'stroke-dasharray .4s cubic-bezier(.2,.8,.2,1)' }}
        />
      </svg>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography sx={{ fontSize: size * 0.28, fontWeight: 800, color: t.text }}>
          {Math.round(pct)}%
        </Typography>
      </Box>
    </Box>
  );
}
